<a class="link" [href]="question?.text" target="_blank" *ngIf="isUser$ | async; else disabledLink">
  {{question?.title != undefined && question?.title != ""?question?.title:question?.text}}
</a>
<ng-template #disabledLink>
  <span class="link"*ngIf="question?.text else placeholder">{{question?.title != undefined && question?.title != ""?question?.title:question?.text }}</span>
</ng-template>

<ng-template #placeholder>
  <span class="link-placholder" translate>no address to link</span>
</ng-template>